import React from 'react';
import { MetaWindowNotice } from './MetaWindowNotice';
import { whatsAppWindowOf, WHATSAPP_WINDOW_CLOSED_TEXT } from './whatsAppWindow';
import { WhatsAppTemplateSender } from './WhatsAppTemplateSender';

interface Props {
  /** Setor com WhatsApp oficial pela Meta direta e conversa pelo WhatsApp (grupo e outros canais não mostram). */
  active: boolean;
  messages: ReadonlyArray<{ isSent: boolean; sentAt: string }>;
  /** A conversa ainda está carregando: sem mensagens não dá para dizer que a janela fechou. */
  loading?: boolean;
  now?: Date;
  /** Com a janela fechada, oferece "Enviar modelo" (precisa do setor e do cliente). */
  sectorId?: number | null;
  contactId?: number | null;
  contactName?: string | null;
  onTemplateSent?: () => void;
}

/** Faixa sobre o compositor do WhatsApp nos setores da Cloud API: reaproveita o aviso de janela da Meta. */
export const WhatsAppWindowNotice: React.FC<Props> = ({ active, messages, loading, now, sectorId, contactId, contactName, onTemplateSent }) => {
  if (!active || (loading && messages.length === 0)) return null;
  const window = whatsAppWindowOf(messages, now);
  // Faixa própria acima do compositor (linha inteira): o aviso e o botão não competem com o campo de texto.
  return (
    <div className="wa-window-bar">
      <MetaWindowNotice window={window} closedText={WHATSAPP_WINDOW_CLOSED_TEXT} />
      {window.state === 'closed' && sectorId && contactId ? (
        <WhatsAppTemplateSender sectorId={sectorId} contactId={contactId} contactName={contactName} onSent={onTemplateSent} />
      ) : null}
    </div>
  );
};
